module.exports = __webpack_public_path__ + "img/hr-small.f32fe04a.svg";